<template>
  <section>
    <HeroBanner
      title="Housing & Toys"
      subtitle="House and entertain your Floof."
      background-color="is-warning"
      icon="home-outline"
    />

    <main role="main">
      <div
        v-for="(section, index) in productSections"
        :key="index"
        class="container section"
      >
        <article>
          <p class="title">{{ section.title }}</p>
          <p class="subtitle">{{ section.subtitle }}</p>
          <b-message v-if="section.alert" type="is-warning" has-icon>
            {{ section.alert }}
          </b-message>

          <div class="content">
            <p v-html="section.description" />

            <ProductList :product-category="section.productCategory" />
          </div>
        </article>
      </div>
    </main>
  </section>
</template>

<script>
import HeroBanner from '@/components/HeroBanner'
import ProductList from '@/components/ProductList'
import { getPageMeta } from '@/utils'

const meta = {
  pageTitle: 'Housing & Toys',
  pageDescription:
    'A spacious living environment is very important for your chinchilla, as they need the freedom to move about their home. According to The Veterinary Center for Birds and Exotics, the minimum cage size for one adult chinchilla should be at least 3 feet by 2 feet by 2 feet. If the chinchillas live together and get along with one another, make sure the cage has a minimum of 2 square feet of floor space per chin.',
  pageURL: 'http://www.chinchillaessentials.com/housing-and-toys',
  pageImg:
    'https://www.chinchillaessentials.com/img/chinchilla_baby_and_mother.jpeg'
}

export default {
  name: 'HousingAndToys',
  components: {
    HeroBanner,
    ProductList
  },
  metaInfo: () => getPageMeta(meta),
  data() {
    return {
      productSections: [
        {
          title: 'Cages',
          subtitle: 'Provide adequate space and safety for your Floof',
          description: `
            <p>A spacious living environment is very important for your chinchilla, as they need the freedom to move about their home. According to The Veterinary Center for Birds and Exotics, the minimum cage size for one adult chinchilla should be at least 3 feet by 2 feet by 2 feet. If the chinchillas live together and get along with one another, make sure the cage has a minimum of 2 square feet of floor space per chin. </p>
            <p>Make sure that cages have solid materials on the floor. Even if a wired cage has a lot of bedding, the wiring will still create pressure sores on a chinchilla’s feet.</p>
            <p>Within the cage, there should be many levels so that your chinchilla can jump. An adult chinchilla can jump as high as 6 feet, and we recommend a cage with this height so that they have enough space to jump. However, if you have space restraints, length is better than height. Since chins are naturally prey in the wild, being on ground level will make them uneasy. Thus, cages should be off of the floor.</p>
            <p>Cage placement is important for the chins. Make sure to keep the cage out of drafts and away from direct sunlight. Dampness, humidity, or being right next to a heat source should be avoided. As chinchillas are sensitive to heat, never let their environment rise above 75 degrees fahrenheit or below 60 degrees Fahrenheit. </p>
            <p>To ensure your chinchilla stays healthy, thoroughly clean their cage at least once a week. Chinchillas are very clean animals, so they will feel uncomfortable in a dirty living space.</p>
          `,
          productCategory: 'cages'
        },
        {
          title: 'Bedding',
          subtitle:
            'Have a comfortable and safe environment for your growing Floof',
          description:
            'Bedding should be replaced at least once a week and thrown away. It is important to know that pine and aromatic shavings are dangerous for chinchillas if ingested, below is a safe and affordable bedding material.',
          productCategory: 'bedding'
        },
        {
          title: 'Furniture',
          subtitle: 'Allow the Floof to have some peace & quiet',
          description:
            'Just as people have couches and beds in their homes, chinchillas need furnishing in their cages as well. Food bowls and water supplies should be supplied at all times. Chinchillas need a hiding spot for sleeping, such as huts, which can be placed on the first floor of the cage.',
          productCategory: 'furniture'
        },
        {
          title: 'Toys',
          subtitle: 'All work and no play makes Floofy a dull boy',
          description: `
            <p>Toys are actually very important for your chin’s health. They are not only fun but also intended to prevent boredom in their cage. While playtime outside of the cage, pvc pipes can be used to create tunnels.</p>
            <p>Chins do not need exercise wheels, but they can be useful way to allow your chin to get exercise. They should be 15 inch wheels and have a solid surface with no spokes. The large enclosed balls should <strong>never</strong> be used, as they do not allow much air flow and the chins could overheat. </p>
            <p>Chinchillas need chewing sticks, their teeth can overgrow if the teeth are not grinded down. You can provide a variety of wooden chew toys, they should be untreated wood only. Manzanita branches are also good for chewing, some chins will also chew on pumice stones or mineral blocks as well.</p>
          `,
          productCategory: 'toys'
        }
      ]
    }
  }
}
</script>
